import React from "react";
import ProductSidenav from "./ProductSidenav";
import Dashboard from "./Dashboard";

const AdminHome = () => {
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <ProductSidenav />
          </div>
          <div className="col-md-9">
            <Dashboard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHome;
